// extracted by mini-css-extract-plugin
export default {"shell":"Layout_shell__sD-4f","main":"Layout_main__Kf7dR"};